const saveChangesModalTemplate = `
<div class="modal-header auto-increase">
	<div class="modal-title">{{ 'app.beneficiary.saveChangesModal.heading' | translate }}</div>
    <hr class="hr-auto-increase"/>
</div>
<div class="modal-body auto-increase">
    <div class="row">
        <div class="col-sm-12">
            <p>{{ 'app.beneficiary.saveChangesModal.content' | translate }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">&nbsp;</div>
    </div>
</div>
<div class="modal-footer auto-increase">
    <div class="col-sm-9">
        <button type="button" class="btn btn-default pull-left" ng-click="ctrl.onDoNotSaveClick()">
            {{ 'app.beneficiary.saveChangesModal.buttons.leave' | translate }}
        </button>
    </div>
    <div class="col-sm-3">
        <button type="button" class="btn btn-primary pull-right" ng-click="ctrl.onStaySaveClick()">
            {{ 'app.beneficiary.saveChangesModal.buttons.stay' | translate }}
        </button>
    </div>
</div>
`;
export default saveChangesModalTemplate;
